import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
		private http:HttpClient,
	) { }
	
	
	getData():Observable<any>
	{
		console.log('environment.name : '+environment.name);
		if(environment.mockApi){
			return this.http.get('assets/mock/mock.api.json');
		}
		return this.http.get(environment.backBaseUrl + 'api');
		
	}
	
	
	//not used
	latlng(address:string):Observable<any>
	{
		
		return this.http.get(environment.backBaseUrl + 'latlng/'+address,
		{
			headers: this.getHeaderAuth(),
		});
	}
	
	
	
	getHeaderAuth(contentType:string = 'application/json', token:string = null):HttpHeaders
	{
		//'application/x-www-form-urlencoded'
		
		let data:any;
		if(token) data = {'x-auth-token': token};
		else data = {};
		
		if(contentType == 'undefined') data['Content-Type'] = undefined;
		else if(contentType != '') data['Content-Type'] = contentType;
		// debugger;
		
		return new HttpHeaders(data);
	}
}
